import { createFileRoute } from '@tanstack/react-router';

import { QualityPacksGridView } from '../../features/quality-packs/quality-packs-grid-view';

export const Route = createFileRoute('/quality-packs/')({
  staticData: {
    layout: 'full-height',
  },
  component: QualityPacksGridView,
});
